<template>

    <div v-bind:class="message == 'payment-confirmation' ? 'visible' : 'hide'" class="modal fade default-modal payment-confirmation-modal modal-payment-template payment-message-modal vtex-front-messages-instance vtex-front-messages-type-fatal in" data-backdrop="static" aria-hidden="false">
        <div class="modal-body default-modal-body payment-confirmation-modal-body">
            <div class="default-modal-security payment-confirmation-security">
                <i class="icon-lock"></i>
            </div>
            <p class="payment-confirmation-content">
                <i class="payment-confirmation-loading loading-img icon-spinner icon-spin">
                    <span data-i18n="global.loading">Carregando...</span>
                </i>
                <span class="payment-confirmation-thanks" data-i18n="global.thanks">Aguarde...</span>
            </p>
            <div id="payment-confirmation-message-container">
                <p class="payment-confirmation-message" data-i18n="paymentData.finishing">Estamos finalizando sua compra.</p>
            </div>
        </div>
    </div>

    <div v-bind:class="message == 'payment-unauthorized' ? 'visible' : 'hide'" class="modal fade default-modal payment-unauthorized-modal modal-payment-unauthorized-template vtex-front-messages-instance vtex-front-messages-type-fatal in" aria-hidden="false">
        <div class="modal-body default-modal-body payment-unauthorized-modal-body">
            <div class="default-modal-security payment-unauthorized-security">
                <i class="icon-lock"></i>
            </div>
            <p class="payment-unauthorized-hello" data-i18n="modal.paymentUnauthorizedReviewData">Por favor, revise seus dados de pagamento</p>
            <div class="default-modal-message payment-unauthorized-message">
                <p class="payment-unauthorized-message1" data-i18n="modal.paymentUnauthorizedMessage1">Sua compra não foi finalizada devido a algum problema na autorização do pagamento.</p>
                <p class="payment-unauthorized-message2" data-i18n="modal.paymentUnauthorizedMessage2">Você pode ter preenchido algum dado incorretamente ou pode ter ocorrido algum problema com a operadora, no caso de compra com cartão.</p>
            </div>
            <button type="button" @click="Close" class="btn btn-large payment-unauthorized-button" data-dismiss="modal" data-i18n="modal.paymentUnauthorizedChangeData">Revisar dados ou pagar de outra forma</button>
        </div>
    </div>

    <div v-bind:class="message == 'validation-error' ? 'visible' : 'hide'" class="modal fade default-modal payment-unauthorized-modal modal-payment-unauthorized-template vtex-front-messages-instance vtex-front-messages-type-fatal in" aria-hidden="false">
        <div class="modal-body default-modal-body payment-unauthorized-modal-body">
            <div class="default-modal-security payment-unauthorized-security">
                <i class="icon-lock"></i>
            </div>
            <p class="payment-unauthorized-hello" data-i18n="modal.paymentUnauthorizedReviewData">Por favor, revise os dados da compra</p>
            <div class="default-modal-message payment-unauthorized-message">
                <p class="payment-unauthorized-message1" data-i18n="modal.paymentUnauthorizedMessage1">Sua compra não foi finalizada devido a algum problema no preenchimento dos dados.</p>
            </div>
            <button type="button" @click="Close" class="btn btn-large payment-unauthorized-button" data-dismiss="modal" data-i18n="modal.paymentUnauthorizedChangeData">Revisar dados</button>
        </div>
    </div>

    <div v-bind:class="message == 'own-list-buy-error' ? 'visible' : 'hide'" class="modal fade default-modal payment-unauthorized-modal modal-payment-unauthorized-template vtex-front-messages-instance vtex-front-messages-type-fatal in" aria-hidden="false">
        <div class="modal-body default-modal-body payment-unauthorized-modal-body">
            <div class="default-modal-security payment-unauthorized-security">
                <i class="icon-lock"></i>
            </div>
            <p class="payment-unauthorized-hello" data-i18n="modal.paymentUnauthorizedReviewData">Compra não permitida</p>
            <div class="default-modal-message payment-unauthorized-message">
                <p class="payment-unauthorized-message1" data-i18n="modal.paymentUnauthorizedMessage1">Você está comprando para uma lista de presentes própria, essa operação não é permitida.</p>
                <p class="payment-unauthorized-message2" data-i18n="modal.paymentUnauthorizedMessage2">Se deseja resgatar os produtos, adicione-os no carrinho diretamente do site e tente novamente.</p>
            </div>
            <button type="button" @click="Close" class="btn btn-large payment-unauthorized-button" data-dismiss="modal" data-i18n="modal.paymentUnauthorizedChangeData">Voltar</button>
        </div>
    </div>

    <div v-bind:class="message == 'unexpected-error' ? 'visible' : 'hide'" class="modal fade default-modal payment-unauthorized-modal modal-payment-unauthorized-template vtex-front-messages-instance vtex-front-messages-type-fatal in" aria-hidden="false">
        <div class="modal-body default-modal-body payment-unauthorized-modal-body">
            <div class="default-modal-security payment-unauthorized-security">
                <i class="icon-lock"></i>
            </div>
            <p class="payment-unauthorized-hello" data-i18n="modal.paymentUnauthorizedReviewData">Erro</p>
            <div class="default-modal-message payment-unauthorized-message">
                <p class="payment-unauthorized-message1" data-i18n="modal.paymentUnauthorizedMessage1">Sua compra não foi finalizada devido a algum problema na conexão com o sistema, tente novamente em alguns instantes.</p>
            </div>
            <button type="button" @click="Close" class="btn btn-large payment-unauthorized-button" data-dismiss="modal" data-i18n="modal.paymentUnauthorizedChangeData">Voltar</button>
        </div>
    </div>

    <div v-bind:class="message == 'notification-error' ? 'visible' : 'hide'" class="modal fade default-modal payment-unauthorized-modal modal-payment-unauthorized-template vtex-front-messages-instance vtex-front-messages-type-fatal in" aria-hidden="false">
        <div class="modal-body default-modal-body payment-unauthorized-modal-body">
            <div class="default-modal-security payment-unauthorized-security">
                <i class="icon-lock"></i>
            </div>
            <p class="payment-unauthorized-hello" data-i18n="modal.paymentUnauthorizedReviewData">Erro</p>
            <div class="default-modal-message payment-unauthorized-message">
                <p class="payment-unauthorized-message1" data-i18n="modal.paymentUnauthorizedMessage1">{{messageText}}</p>
            </div>
            <button type="button" @click="Close" class="btn btn-large payment-unauthorized-button" data-dismiss="modal" data-i18n="modal.paymentUnauthorizedChangeData">Voltar</button>
        </div>
    </div>

    <div v-bind:class="show ? 'visible' : 'hide'" class="modal-backdrop fade in"></div>

</template>

<script>

    export default {
        data: () => ({
            message: '',
            messageText: '',
            show: false,
            instantPaymentQrCodeImage: '',
            instantPaymentQrCode:''
        }),
        mounted() {
            var self = this;

            this.emitter.on('showMessage', args => {
                console.log(args.messageType);
                self.message = args.messageType;
                switch (args.messageType) {
                    case 'payment-confirmation': self.show = true; break;
                    case 'payment-unauthorized': self.show = true; break;
                    case 'validation-error': self.show = true; break;
                    case 'unexpected-error': self.show = true; break;
                    case 'notification-error': { self.show = true; self.messageText = args.messageText; break; }
                    case 'own-list-buy-error': self.show = true; break;
                    case 'own-list-buy-error': self.show = true; break;
                    default: self.show = false; break;
                }
            });

            this.emitter.on('closeMessage', function () {
                self.Close();
            });

        },
        methods: {
            Close() {
                this.show = false;
                this.message = '';
                this.messageText = '';
            }
        },
        computed: {

        }
    }

</script>